import type { SessionConfig } from '@xing-com/crate-xinglet/internal';

import { configureFetch as configureFetchInternal } from '../configure-fetch';
import { configureRequestWithAcceptLanguageHeader } from '../shared/configure-request-with-accept-language-header';
import type { Fetch } from '../types';

import { configureRequestWithCsrfHeader } from './configure-request-with-csrf-header';
import { configureResponseWithAuthCheck } from './configure-response-with-auth-check';
import { createRequest } from './create-request';

export function configureFetch(sessionConfig: SessionConfig): Fetch {
  return configureFetchInternal(globalThis.fetch, createRequest, {
    requestConfigurators: [
      configureRequestWithAcceptLanguageHeader(sessionConfig),
      configureRequestWithCsrfHeader(),
    ],
    responseConfigurators: [configureResponseWithAuthCheck(sessionConfig)],
  });
}
